import PropTypes from 'prop-types'
import React from 'react'
import styles from './style.module.scss'
import { Col, Row } from 'react-bootstrap'

function CommonFooter({ logo, description, links = [], socialLinks = [], appLinks = [], connectText = 'Connect With Us', downloadText = 'Get the App on', CustomLink, MyImage, pageRouterComp }) {
  const leftSideLinks = links.filter((_, index) => index % 2 === 0)
  const rightSideLinks = links.filter((_, index) => index % 2 !== 0)
  return (
        <footer className={`${styles.siteFooter} text-center text-sm-start`} id="footer">
            <div className="container">
                <div className={`${styles.footerBottom}`}>
                    <Row>
                        {/* <Col xl={7} lg={6}> */}
                        <Col >
                            <Row >
                                <Col xl={5} lg={12} sm={12} >
                                    <div className={`${styles.logoBlock}`}>
                                        <div className='d-flex align-items-center md-justify-content-center justify-content-sm-start mb-3'>
                                            <div className={`${styles.footerLogo} d-inline-block`}>
                                                <MyImage src={logo} alt="logo" layout="responsive" />
                                            </div>
                                        </div>
                                        <p>{description}</p>
                                    </div>
                                </Col>
                                <Col xl={4} lg={12} sm={12} >
                                    <Row>
                                        <Col xl={6} sm={12}>
                                            <ul className={`${styles.footerMenu} mt-3 mt-sm-0`}>
                                                {leftSideLinks.map(({ label, href }, i) => (
                                                    <li key={href}>
                                                        {pageRouterComp ? <CustomLink href={href} prefetch={false}><a>{label}</a></CustomLink> : <CustomLink href={href} prefetch={false}>{label}</CustomLink>
                                                        }
                                                    </li>
                                                ))}
                                            </ul>
                                        </Col>
                                        <Col xl={6} sm={12}>
                                            <ul className={`${styles.footerMenu} mt-3 mt-sm-0`}>
                                                {rightSideLinks.map(({ label, href }, i) => (
                                                    <li key={href}>
                                                        {pageRouterComp ? <CustomLink href={href} prefetch={false}><a>{label}</a></CustomLink> : <CustomLink href={href} prefetch={false}>{label}</CustomLink>
                                                        }
                                                    </li>
                                                ))}
                                            </ul>
                                        </Col>
                                    </Row>
                                </Col>
                                {/* Connect With Us section hidden for now
                                <Col xl={3} lg={12} sm={12} className={styles.connectWithUs}>
                                    <p>{connectText}</p>
                                    <ul className={`${styles.socialMenu} d-flex text-uppercase justify-content-sm-start`}>
                                        {socialLinks.map(({ icon, href, alt }, i) => (
                                            <li key={i}>
                                                <a href={href} target="_blank" rel="noreferrer">
                                                    <MyImage src={icon} alt={alt} height={110} width={110} />
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </Col>
                                */}
                            </Row>
                        </Col>
                    </Row>
                    <div className={`${styles.downloadContainer}`}>
                        <p >{downloadText}</p>
                        <div>
                            {appLinks.map(({ href, icon, alt }, i) => (
                                <div className="cursor-pointer" key={i}>
                                    <a href={href} target="_blank" rel="noopener noreferrer nofollow">
                                        <MyImage src={icon} alt={alt} height={41} width={110} />
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
  )
}

export default CommonFooter

CommonFooter.propTypes = {
  logo: PropTypes.any,
  description: PropTypes.string,
  links: PropTypes.array,
  socialLinks: PropTypes.array,
  appLinks: PropTypes.array,
  connectText: PropTypes.string,
  downloadText: PropTypes.string,
  CustomLink: PropTypes.any,
  MyImage: PropTypes.any,
  pageRouterComp: PropTypes.bool
}
